export const POST_AUTOMATION_HOOK = 'POST_AUTOMATION_HOOK'
export const GET_PROJECT_SHEETS_AND_HOOKS = 'GET_PROJECT_SHEETS_AND_HOOKS'
export const CHECK_MISSING_COLUMNS = 'CHECK_MISSING_COLUMNS'
export const RESET_SUCCESS_MESSAGE = 'RESET_SUCCESS_MESSAGE'
